import { redirect } from 'vike/abort';

import { isIosNative } from '@/renderer/utils/isIosNative';

/**
 * The whole `/order/*` tree is web checkout (Stripe). On iOS that would violate
 * App Store Review Guideline 3.1.1 (digital purchases must use Apple's In-App
 * Purchase), so we send iOS users to their content instead. Android + web keep
 * the normal order flow.
 *
 * This is the safety net; the in-app CTAs that link here are also hidden on iOS
 * (isIosNative). The guard runs on client-side navigation where window.Capacitor
 * is available; on the server / web it evaluates false and does nothing. The
 * sibling `+Layout.tsx` covers the one path the guard can miss (an in-app reload
 * that boots the prerendered shell directly at `/order`).
 *
 * `/release-center` rather than `/`: the app's `/` route bounces signed-in
 * native users to the Release Center anyway, so go there directly (no double
 * hop); a signed-out user is sent on to sign-in by the guarded-area check.
 */
export function guard(_pageContext: Vike.PageContext) {
  if (isIosNative()) {
    throw redirect('/release-center');
  }
}
